import { render, staticRenderFns } from "./merchantManageList.vue?vue&type=template&id=159168c3&scoped=true"
import script from "./merchantManageList.vue?vue&type=script&lang=js"
export * from "./merchantManageList.vue?vue&type=script&lang=js"
import style0 from "./merchantManageList.vue?vue&type=style&index=0&id=159168c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159168c3",
  null
  
)

export default component.exports